module.exports = __webpack_public_path__ + "static/media/Link.c9988fdc.png";